<template>
    <div class="ds-employees-chips">
        <span v-for="chip in chips" :key="`${chip.kind}-${chip.id}`" class="ds-employees-chip">
            <span class="ds-employees-chip-label">{{ chip.name }}</span>
            <button
                type="button"
                class="ds-employees-chip-remove"
                :aria-label="`Убрать фильтр ${chip.name}`"
                @click="emit('remove', chip)"
            >
                <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" /></svg>
            </button>
        </span>
        <button type="button" class="ds-employees-chips-reset" @click="emit('reset-all')">Сбросить всё</button>
        <span v-if="foundText" class="ds-employees-chips-found" aria-live="polite">{{ foundText }}</span>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { FilterChip } from './employeesList'

interface Props {
    chips: FilterChip[],
    // N — count с текущими условиями; M — тот же сегмент и поиск без фильтров. null — нет данных.
    found: number | null,
    total: number | null
}

const { chips, found, total } = defineProps<Props>()

const emit = defineEmits<{
    (e: 'remove', chip: FilterChip): void
    (e: 'reset-all'): void
}>()

// Пока N неизвестен — ничего; без M — «Найдено N», без ложного нуля.
const foundText = computed(() => {
    if (found === null) return ''
    const n = found.toLocaleString('ru-RU')
    return total === null ? `Найдено ${n}` : `Найдено ${n} из ${total.toLocaleString('ru-RU')}`
})
</script>
